import { render, staticRenderFns } from "./SangriaCaixa.vue?vue&type=template&id=36798ea8&"
import script from "./SangriaCaixa.vue?vue&type=script&lang=js&"
export * from "./SangriaCaixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports